module.exports = __webpack_public_path__ + "static/img/jiayondianqi.04428c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jiayondianqi.png
// module id = Oio1
// module chunks = 0